import React from 'react';

interface OwnProps {
  iframeRef?: React.RefObject<HTMLIFrameElement | null>;
  src?: string;
  tag?: string | object;
}

export type Props = React.IframeHTMLAttributes<HTMLIFrameElement> & OwnProps;

const Iframe: React.FC<Props> = ({
  iframeRef,
  frameBorder = 0,
  allowFullScreen = false,
  height = '100%',
  width = '100%',
  scrolling = 'no',
  ...rest
}) => (
  <iframe
    {...rest}
    frameBorder={frameBorder}
    allowFullScreen={allowFullScreen}
    height={height}
    width={width}
    scrolling={scrolling}
    ref={iframeRef}
  />
);

export default Iframe;
